import { computed, watch } from 'vue'

/**
 * Conditional visibility for genome_reference in Nanopore assays.
 * Shows the field only when live_read_mapping is enabled and resets
 * its value when hidden.
 *
 * @param {Object} dv - The reactive detail view object
 */
export function useNanoporeConditionalFields(dv) {
  const liveReadMapping = computed(
    () => dv.editedRecord['live_read_mapping']?.value,
  )

  watch(liveReadMapping, (enabled) => {
    if (!enabled) {
      dv.resetField({ name: 'genome_reference' })
    }
  })

  return { liveReadMapping }
}
